export default __webpack_public_path__ + "static/media/1.cca0d63d.jpg";